export const auditStatuses = {
  missed: 'Missed',
  upcoming: 'Upcoming',
  completed: 'Completed',
};

export const auditFrequencies = ['Daily', 'Weekly', 'Monthly', 'Quarterly', '6 months', 'Annual', '2 years', '3 years', '5 years'];
